/* Federosé theme: header, phone menu, search, bag, product page, photo zoom, currency, brand font. */
(function () {
  "use strict";
  const T = window.theme || { routes: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia("(prefers-reduced-motion: reduce)");

  // money from cents, in the cart's currency (whole amounts without decimals)
  const money = (cents, cur) => {
    const v = cents / 100, c = cur || T.currency || "SEK";
    try { return new Intl.NumberFormat(T.locale || undefined, { style: "currency", currency: c, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return v.toFixed(2) + " " + c; }
  };
  const esc = s => String(s == null ? "" : s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  let toastTimer;
  const toast = msg => { const t = $("#toast"); if (!t) return; t.textContent = msg; t.classList.add("show"); clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove("show"), 2200); };

  /* ---------- header: white at the top of the homepage, dark once you scroll ---------- */
  const onScroll = () => document.body.classList.toggle("scrolled", scrollY > 10);
  addEventListener("scroll", onScroll, { passive: true }); onScroll();
  const setHdr = () => { const h = $("#siteHeader"); if (h) document.documentElement.style.setProperty("--hdr", (h.getBoundingClientRect().bottom + 8) + "px"); };
  addEventListener("resize", setHdr); setHdr();

  /* ---------- phone menu ---------- */
  let menuTimer;
  function setMenu(open) {
    const nav = $("#mobileNav"), btn = $("#menuBtn"); if (!nav) return;
    clearTimeout(menuTimer);
    if (open) { setSearch(false); nav.classList.remove("closing"); nav.hidden = false; }
    else if (!nav.hidden) { nav.classList.add("closing"); menuTimer = setTimeout(() => { nav.hidden = true; nav.classList.remove("closing"); }, 260); }
    document.body.classList.toggle("menu-open", open);
    btn && btn.setAttribute("aria-expanded", open);
    btn && btn.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  }
  $("#menuBtn") && $("#menuBtn").addEventListener("click", () => setMenu($("#mobileNav").hidden));
  $$(".mtoggle").forEach(b => b.addEventListener("click", () => {
    const open = b.getAttribute("aria-expanded") !== "true";
    b.setAttribute("aria-expanded", open);
    document.getElementById(b.getAttribute("aria-controls")).hidden = !open;
  }));

  /* ---------- search panel with live results ---------- */
  const sPanel = $("#searchPanel"), sInput = $("#searchInput"), sBox = $("#searchResults");
  let searchTimer, searchReq = 0;
  function popular() {
    const words = (sBox && sBox.dataset.popular || "").split(",").map(w => w.trim()).filter(Boolean);
    sBox.innerHTML = words.length ? `<div><div class="slabel">Popular searches</div><div class="schips">${words.map(w => `<button type="button" data-q="${esc(w)}">${esc(w)}</button>`).join("")}</div></div>` : "";
  }
  async function runSearch() {
    const q = sInput.value.trim();
    $("#searchClose").setAttribute("aria-label", sInput.value ? "Clear search" : "Close search");
    if (!q) { popular(); return; }
    const id = ++searchReq;
    try {
      const url = `${T.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last`;
      const html = await (await fetch(url)).text();
      if (id !== searchReq) return;
      const doc = new DOMParser().parseFromString(html, "text/html");
      const sec = doc.querySelector(".shopify-section") || doc.body;
      sBox.innerHTML = sec.innerHTML;
      brandify(sBox);
    } catch (e) { if (id === searchReq) sBox.innerHTML = `<p class="snone">Search isn't available right now. Press Enter to see all results.</p>`; }
  }
  let sCloseTimer;
  function setSearch(open) {
    if (!sPanel) return;
    clearTimeout(sCloseTimer);
    if (open) {
      setMenu(false); closeCart();
      sPanel.classList.remove("closing"); sPanel.hidden = false;
      document.body.classList.add("search-open");
      $("#searchBtn").setAttribute("aria-expanded", "true");
      runSearch(); setTimeout(() => sInput.focus(), 50);
    } else if (!sPanel.hidden) {
      sPanel.classList.add("closing");
      document.body.classList.remove("search-open");
      $("#searchBtn").setAttribute("aria-expanded", "false");
      sCloseTimer = setTimeout(() => { sPanel.hidden = true; sPanel.classList.remove("closing"); }, 260);
    }
  }
  if (sPanel) {
    $("#searchBtn").addEventListener("click", () => setSearch(sPanel.hidden));
    // the X clears what was typed; only when the bar is already empty does it close the search
    $("#searchClose").addEventListener("click", () => { if (sInput.value) { sInput.value = ""; runSearch(); sInput.focus(); } else setSearch(false); });
    sInput.addEventListener("input", () => { clearTimeout(searchTimer); searchTimer = setTimeout(runSearch, 180); });
    sBox.addEventListener("click", e => {
      const chip = e.target.closest("[data-q]"), tab = e.target.closest("[data-tab]");
      if (chip) { sInput.value = chip.dataset.q; runSearch(); sInput.focus(); }
      else if (tab && !tab.disabled) {
        $$("[data-tab]", sBox).forEach(t => t.setAttribute("aria-selected", t === tab));
        $$("[data-panel]", sBox).forEach(p => p.hidden = p.dataset.panel !== tab.dataset.tab);
      }
    });
    // a tap anywhere outside the header closes the search; the page stays fully bright
    document.addEventListener("pointerdown", e => { if (!sPanel.hidden && !e.target.closest("#siteHeader")) setSearch(false); });
  }

  /* ---------- bag (Shopify cart) ---------- */
  const drawer = $("#drawer"), scrim = $("#scrim");
  function openCart() { if (!drawer) return; renderCart(); drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); scrim.hidden = false; }
  function closeCart() { if (!drawer) return; drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); scrim.hidden = true; }
  async function getCart() { return (await fetch(T.routes.cart + ".js", { headers: { Accept: "application/json" } })).json(); }
  function paintDot(n) {
    const dot = $("#cartDot"), btn = $("#cartBtn");
    if (dot) dot.hidden = n === 0;
    btn && btn.setAttribute("aria-label", n ? `Open bag, ${n} item${n > 1 ? "s" : ""}` : "Open bag, empty");
    const c = $("#bagCount"); if (c) c.textContent = n ? `(${n})` : "";
  }
  async function pairsFor(cart) {
    if (!cart.items.length || !T.routes.recommendations) return [];
    try {
      const last = cart.items[cart.items.length - 1];
      const r = await (await fetch(`${T.routes.recommendations}.json?product_id=${last.product_id}&limit=4&intent=complementary`)).json();
      let list = (r.products || []);
      if (!list.length) list = (await (await fetch(`${T.routes.recommendations}.json?product_id=${last.product_id}&limit=4`)).json()).products || [];
      const inBag = new Set(cart.items.map(i => i.product_id));
      return list.filter(p => p.available && !inBag.has(p.id)).slice(0, 2);
    } catch (e) { return []; }
  }
  async function renderCart(cartIn) {
    if (!drawer) return;
    const cart = cartIn || await getCart();
    paintDot(cart.item_count);
    const lines = $("#lines"), foot = $("#drawerFoot");
    if (!cart.items.length) {
      lines.innerHTML = `<div class="empty"><b>Your bag is empty</b>Find something you love in the collection.<div style="margin-top:20px"><a class="btn btn--ink" href="${T.routes.root}collections/all">Shop now</a></div></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    $("#subtotal").textContent = money(cart.total_price, cart.currency);
    lines.innerHTML = cart.items.map((it, i) => `
      <div class="line">
        ${it.image ? `<img src="${esc(it.image)}&width=200" alt="">` : `<div class="phs"></div>`}
        <div>
          <div class="line__top"><h3><a href="${esc(it.url)}">${esc(it.product_title)}</a></h3><span class="price">${money(it.final_line_price, cart.currency)}</span></div>
          ${it.variant_title && !it.product_has_only_default_variant ? `<div class="v">${esc(it.variant_title)}</div>` : ""}
          <div class="line__bottom">
            <div class="qty"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button></div>
            <button class="rm" type="button" data-line="${i + 1}" data-q="0">Remove</button>
          </div>
        </div>
      </div>`).join("");
    const pairs = await pairsFor(cart);
    if (pairs.length) {
      lines.insertAdjacentHTML("beforeend", `<div class="pairs"><h4>Pairs well with</h4><div class="pairs__row">${pairs.map(p => `
        <a class="pair" href="${esc(p.url)}">${p.featured_image ? `<img src="${esc(p.featured_image)}&width=400" alt="" loading="lazy">` : ""}<b>${esc(p.title)}</b><span>${money(p.price, cart.currency)}</span><em>Choose size</em></a>`).join("")}</div></div>`);
    }
    brandify(lines);
  }
  async function changeLine(line, quantity) {
    const r = await fetch(T.routes.cartChange + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line, quantity }) });
    renderCart(await r.json());
  }
  if (drawer) {
    $("#cartBtn").addEventListener("click", e => { e.preventDefault(); openCart(); });
    $("#drawerClose").addEventListener("click", closeCart);
    scrim.addEventListener("click", closeCart);
    $("#lines").addEventListener("click", e => { const b = e.target.closest("button[data-line]"); if (b) changeLine(+b.dataset.line, +b.dataset.q); });
  }

  /* ---------- product page: sizes, add to bag ---------- */
  const pj = $("#productJson");
  if (pj) {
    const product = JSON.parse(pj.textContent);
    const form = $("#productForm"), idInput = $("#variantId"), addBtn = $("#addBtn");
    const opts = $$(".opt", form);
    const chosen = {};
    opts.forEach(o => { const on = $(".size[aria-pressed='true']", o) || $(".size", o); chosen[+o.dataset.index] = on && on.dataset.value; });
    const findVariant = () => product.variants.find(v => v.options.every((val, i) => chosen[i] === undefined || chosen[i] === val));
    function paint() {
      const v = findVariant();
      opts.forEach(o => {
        const i = +o.dataset.index;
        $$(".size", o).forEach(b => {
          b.setAttribute("aria-pressed", b.dataset.value === chosen[i]);
          const test = Object.assign({}, chosen, { [i]: b.dataset.value });
          const match = product.variants.find(x => x.options.every((val, k) => test[k] === undefined || test[k] === val));
          b.disabled = !match || !match.available;
        });
      });
      if (!v) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? "Add to bag" : "Sold out";
      const pr = $("#pdpPrice");
      if (pr) pr.innerHTML = `<span class="price">${v.compare_at_price > v.price ? `<span class="sale">${money(v.price)}</span><s>${money(v.compare_at_price)}</s>` : money(v.price)}</span>`;
      const ch = $("#pdpCharity"); if (ch) ch.textContent = money(Math.round(v.price * (T.charityPercent || 10) / 100));
      const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
    }
    opts.forEach(o => o.addEventListener("click", e => { const b = e.target.closest(".size"); if (!b || b.disabled) return; chosen[+o.dataset.index] = b.dataset.value; paint(); }));
    if (opts.length) paint();
    form.addEventListener("submit", async e => {
      e.preventDefault();
      addBtn.disabled = true;
      try {
        const r = await fetch(T.routes.cartAdd + ".js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
        const data = await r.json();
        if (!r.ok) { toast(data.description || "Couldn't add this to your bag."); return; }
        await renderCart(); openCart();
        const dot = $("#cartDot"); if (dot) { dot.classList.remove("pop"); void dot.offsetWidth; dot.classList.add("pop"); }
      } catch (err) { toast("Couldn't add this to your bag. Please try again."); }
      finally { const v = findVariant(); addBtn.disabled = v ? !v.available : false; }
    });
  }

  /* ---------- "You may also like" ---------- */
  const rec = $("[data-recommendations]");
  if (rec && !rec.children.length) {
    fetch(rec.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const inner = doc.querySelector("[data-recommendations]");
      if (inner && inner.innerHTML.trim()) { rec.innerHTML = inner.innerHTML; brandify(rec); }
    }).catch(() => {});
  }

  /* ---------- product photo slider ---------- */
  const pg = $("#pg");
  if (pg && $("#pgTrack")) {
    const track = $("#pgTrack"), slides = $$(".pg__slide", track);
    const srcs = slides.map(s => s.dataset.zoom).filter(Boolean);
    const marks = $$(".pg__dots button, .pg__thumbs button", pg);
    const prev = $(".pg__prev", pg), next = $(".pg__next", pg);
    let cur = 0;
    const go = i => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth }); };
    const sync = () => { cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); marks.forEach(m => m.setAttribute("aria-current", +m.dataset.i === cur)); prev.disabled = cur === 0; next.disabled = cur === slides.length - 1; };
    track.addEventListener("scroll", () => requestAnimationFrame(sync), { passive: true });
    prev.addEventListener("click", () => go(cur - 1)); next.addEventListener("click", () => go(cur + 1));
    marks.forEach(m => m.addEventListener("click", () => go(+m.dataset.i)));
    track.addEventListener("keydown", e => { if (e.key === "ArrowLeft") go(cur - 1); if (e.key === "ArrowRight") go(cur + 1); if (e.key === "Enter" && srcs.length) openZoom(srcs, cur); });
    const zb = $(".pg__zoom", pg); zb && zb.addEventListener("click", () => openZoom(srcs, cur));
    let downX = 0;
    track.addEventListener("pointerdown", e => { downX = e.clientX; });
    track.addEventListener("click", e => { if (srcs.length && Math.abs(e.clientX - downX) < 8 && e.target.closest(".pg__slide")) openZoom(srcs, cur); });
    sync();
  }

  /* ---------- full-screen zoom ---------- */
  const zEl = $("#zoom"), zStage = $("#zoomStage"), zImg = $("#zoomImg");
  const Z = { list: [], i: 0, zoomed: false, scale: 2.5, ox: 50, oy: 50 };
  function zApply() { zImg.style.transformOrigin = `${Z.ox}% ${Z.oy}%`; zImg.style.transform = Z.zoomed ? `scale(${Z.scale})` : "none"; zStage.classList.toggle("is-zoomed", Z.zoomed); }
  function zShow(i) {
    Z.i = (i + Z.list.length) % Z.list.length; Z.zoomed = false; Z.ox = Z.oy = 50;
    zImg.src = Z.list[Z.i]; zImg.alt = `Product photo ${Z.i + 1} of ${Z.list.length}`;
    $("#zoomCount").textContent = Z.list.length > 1 ? `${Z.i + 1} / ${Z.list.length}` : "";
    $("#zoomPrev").disabled = $("#zoomNext").disabled = Z.list.length < 2; zApply();
  }
  function openZoom(list, i) { if (!zEl || !list.length) return; Z.list = list; zShow(i); zEl.hidden = false; document.body.style.overflow = "hidden"; $("#zoomClose").focus(); }
  function closeZoom() { if (!zEl || zEl.hidden) return; zEl.hidden = true; document.body.style.overflow = ""; Z.zoomed = false; zApply(); }
  if (zEl) {
    const zPoint = e => { const r = zImg.getBoundingClientRect(), s = Z.zoomed ? Z.scale : 1, w = r.width / s, h = r.height / s, left = r.left + (r.width - w) * Z.ox / 100, top = r.top + (r.height - h) * Z.oy / 100; return [Math.max(0, Math.min(100, (e.clientX - left) / w * 100)), Math.max(0, Math.min(100, (e.clientY - top) / h * 100))]; };
    let zDown = null;
    zStage.addEventListener("pointerdown", e => { zDown = { x: e.clientX, y: e.clientY, ox: Z.ox, oy: Z.oy, moved: false }; zStage.setPointerCapture(e.pointerId); });
    zStage.addEventListener("pointermove", e => {
      if (Z.zoomed && e.pointerType === "mouse" && !zDown) { [Z.ox, Z.oy] = zPoint(e); zApply(); return; }
      if (!zDown) return;
      const dx = e.clientX - zDown.x, dy = e.clientY - zDown.y;
      if (Math.abs(dx) + Math.abs(dy) > 6) zDown.moved = true;
      if (Z.zoomed && zDown.moved) {
        zStage.classList.add("dragging"); const r = zImg.getBoundingClientRect();
        Z.ox = Math.max(0, Math.min(100, zDown.ox - dx / (r.width / Z.scale) * 100 / (Z.scale - 1)));
        Z.oy = Math.max(0, Math.min(100, zDown.oy - dy / (r.height / Z.scale) * 100 / (Z.scale - 1))); zApply();
      }
    });
    zStage.addEventListener("pointerup", e => {
      if (!zDown) return; const d = zDown; zDown = null; zStage.classList.remove("dragging");
      const dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (!d.moved) { if (!Z.zoomed) { [Z.ox, Z.oy] = zPoint(e); Z.zoomed = true; } else Z.zoomed = false; zApply(); }
      else if (!Z.zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) zShow(Z.i + (dx < 0 ? 1 : -1));
    });
    zStage.addEventListener("pointercancel", () => { zDown = null; zStage.classList.remove("dragging"); });
    $("#zoomPrev").addEventListener("click", () => zShow(Z.i - 1));
    $("#zoomNext").addEventListener("click", () => zShow(Z.i + 1));
    $("#zoomClose").addEventListener("click", closeZoom);
    document.addEventListener("keydown", e => { if (zEl.hidden) return; if (e.key === "Escape") { e.stopImmediatePropagation(); closeZoom(); } if (e.key === "ArrowLeft") zShow(Z.i - 1); if (e.key === "ArrowRight") zShow(Z.i + 1); }, true);
  }

  /* ---------- homepage slideshow ---------- */
  const slidesEl = $("#slides");
  if (slidesEl) {
    const items = $$(".slide", slidesEl), dots = $$(".dots button", slidesEl);
    let cur = 0, timer;
    const show = i => { cur = (i + items.length) % items.length; items.forEach((s, j) => { s.classList.toggle("on", j === cur); s.setAttribute("aria-hidden", j !== cur); }); dots.forEach((d, j) => d.setAttribute("aria-current", j === cur)); };
    dots.forEach(d => d.addEventListener("click", () => { show(+d.dataset.s); clearInterval(timer); }));
    if (items.length > 1 && !reduced.matches) timer = setInterval(() => show(cur + 1), 5500);
  }

  /* ---------- currency (Shopify Markets): pick a country, the store reloads in its currency ---------- */
  const curBtn = $("#curBtn"), curList = $("#curList");
  if (curBtn && curList) {
    const setCurList = open => { curList.hidden = !open; curBtn.setAttribute("aria-expanded", open); if (open) { const s = $("[aria-selected='true']", curList); s && s.focus(); } };
    const pick = code => { const f = curBtn.closest("form"); f.querySelector("[name=country_code]").value = code; f.submit(); };
    curBtn.addEventListener("click", e => { e.stopPropagation(); setCurList(curList.hidden); });
    curList.addEventListener("click", e => { const li = e.target.closest("[data-code]"); if (li) pick(li.dataset.code); });
    curList.addEventListener("keydown", e => {
      const items = [...curList.children], i = items.indexOf(document.activeElement);
      if (e.key === "ArrowDown") { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      if (e.key === "ArrowUp") { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      if (e.key === "Enter" && i >= 0) { e.preventDefault(); pick(items[i].dataset.code); }
      if (e.key === "Escape") { setCurList(false); curBtn.focus(); }
    });
    document.addEventListener("pointerdown", e => { if (!curList.hidden && !e.target.closest("#curWrap")) setCurList(false); });
  }

  /* ---------- copy email (contact page) ---------- */
  const copy = $("#copyMail");
  copy && copy.addEventListener("click", () => {
    const addr = $("#mailAddr").textContent;
    (navigator.clipboard ? navigator.clipboard.writeText(addr) : Promise.reject()).then(() => toast("Email copied"), () => {
      const r = document.createRange(); r.selectNodeContents($("#mailAddr")); const s = getSelection(); s.removeAllRanges(); s.addRange(r); toast("Selected, press Ctrl+C");
    });
  });

  /* ---------- Escape closes whatever is open ---------- */
  document.addEventListener("keydown", e => { if (e.key === "Escape") { closeCart(); setMenu(false); setSearch(false); } });

  /* ---------- every "Federosé" in Vollkorn, regular weight (not inside longer words or emails) ---------- */
  function brandify(root) {
    if (!root) return;
    const NAME = /(?<![\p{L}\d@.])(federos[eé])(?![\p{L}\d@])/iu;
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: n => NAME.test(n.nodeValue) && !n.parentElement.closest(".brand-word,script,style,textarea,option,title,input") ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT });
    const nodes = []; while (w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach(node => {
      const frag = document.createDocumentFragment();
      node.nodeValue.split(new RegExp(NAME.source, "giu")).forEach((part, i) => {
        if (i % 2) { const s = document.createElement("span"); s.className = "brand-word"; s.textContent = part; frag.appendChild(s); }
        else if (part) frag.appendChild(document.createTextNode(part));
      });
      node.replaceWith(frag);
    });
  }
  brandify(document.body);
})();
